<ng-container *ngIf="controlInfo as c" [formGroup]="parentFormGroup">
  <label for="simple-input-text-form-{{controlId}}" class="form-label">
    {{c.alias ?? c.name}}
    <span *ngIf="c.required" class="text-red-400">*</span>
    <small *ngIf="c.label" class="text-muted text-xs">{{c.label}}</small>
  </label>
  <input [formControlName]="c.name" type="text" class="form-control" id="simple-input-text-form-{{controlId}}"
    [matTooltip]="c.toolTip ?? ''" [matAutocomplete]="auto_complete">
  <mat-autocomplete #auto_complete>
    <mat-option *ngFor="let item of filteredSelectValues$|async" [value]="item.value">{{item.key}}</mat-option>
  </mat-autocomplete>
</ng-container>